import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getSegment } from 'personalization-lib/utils/personalizationStrategy/segments';
import SegmentLink from './SegmentLink';
import SegmentName from './SegmentName';
import { jsx as _jsx } from "react/jsx-runtime";
const TargetingInfo = ({
  targetingConfig,
  targetingState,
  linkToSegment
}) => {
  const segment = getSegment({
    targetingConfig
  });
  if (!segment) {
    return /*#__PURE__*/_jsx(TruncateString, {
      children: targetingState ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "personalizationLib.targeting.filteredVisitors"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "personalizationLib.targeting.allVisitors"
      })
    });
  }
  return linkToSegment ? /*#__PURE__*/_jsx(SegmentLink, {
    identifier: segment
  }) : /*#__PURE__*/_jsx(SegmentName, {
    identifier: segment
  });
};
export default TargetingInfo;